const devEnv = {

  userSignupAge: 19,

  googleMapKey: 'AIzaSyBJs2f0TNNui_OcRHgVRTIsJAvGQ0EB7oA',
  googleAuthClientId: '798107650474-2s9ggqp33bvrlj2bv5seotc6q2a2lpu0.apps.googleusercontent.com',

  facebookAppId: '1156270755104800',

  // business profile 284629430222460
  defaultBusinessSlug: 'budler',
  businessProfileUrl: 'https://auth.beta.api.unoapp.io', 
  businessProfileUrlApiToken: '6d696355eb70de2f31e0a80c36c87c8918e8798f',
  businessNotToRedirect: ['0cdb5e80-a029-4b7d-8d34-c02bfd4078ae'], // do not redirect for this business if has 1 location only

  // user or login
  loginUrl: 'https://cannabis-users.staging.v2.api.unoapp.io',
  loginAppId: 'a018a0480786fe3feb59304a6f8247d3c402089e',
  loginAppSecret: '0e3da4884456a6cd8a8f00ed4c8e1120ac67b5a3',
  loginApiToken: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
  
  // product
  productUrl: 'https://cannabis-product.staging.v2.api.unoapp.io',
  productAppId: '19SFVHpxjoPvCTYF3AVBGVhOE5GGr15X',
  productAppSecret: 'JvVCzQZHbvGxZUgFVD2cPjEYAl0IlJHh',
  
  // location
  locationUrl: 'https://locations-service.beta.api.unoapp.io',
  apiToken: '5c04d3e13c6d52b1507b550ec9307c0c98778616',
  // authToken: 'b13b98c95f73e1443c9eab88609ef6047144a5b1',
  
  // cart
  cartUrl: 'https://cannabis-cart.staging.v2.api.unoapp.io',

  // app detail
  appVersion: 'testappversion',
  appPlatform: 'web',

  // Pubnub
  pubnubSubscribeKey: 'sub-c-5529b7c8-1b45-11ea-8927-2eba4cd9d31a',
  pubnubPublishKey: 'pub-c-025ede3e-dab4-4a7e-9bcd-21b4c28c354f',

  // order 
  orderUrl: 'https://cannabis-orders.staging.v2.api.unoapp.io',

  
  // Business id
  businessId: '30a725ca-3027-4aa5-a5fe-1eab625e4e79',
  moneris: {
    id: 'ht3E8Z8OZSAH77N',
    url: 'https://esqa.moneris.com/HPPtoken/index.php',
  },
  paysafe: {
    url: 'https://hosted.paysafe.com/js/v1/latest/paysafe.min.js',
    username: 'OT-327700',
    password: 'B-qa2-0-5ec3f480-0-302c0214155be72773dfa195c1fbd6bf1baa7d6f013fb7ce0214667cf3b9401ba32bf848312b9e4be754cbb834de', // qa url
    apiKey: 'T1QtMzI3NzAwOkItcWEyLTAtNWVjM2Y0ODAtMC0zMDJjMDIxNDE1NWJlNzI3NzNkZmExOTVjMWZiZDZiZjFiYWE3ZDZmMDEzZmI3Y2UwMjE0NjY3Y2YzYjk0MDFiYTMyYmY4NDgzMTJiOWU0YmU3NTRjYmI4MzRkZQ==',
    options: {
      environment: "TEST",
      fields: {
        cardNumber: {
          selector: "#cardNumber",
          placeholder: "Card number"
        },
        expiryDate: {
          selector: "#expiryDate",
          placeholder: "Expiry date"
        },
        cvv: {
          selector: "#cvv",
          placeholder: "CVV"
        }
      }, 
      style: {
        input: {
          "font-weight": "normal",
          "font-size": "16px",
          "color": "#9d9d9d",
        }
      }
    },
  },

  elavon:{
    tokenurl: 'https://api.demo.convergepay.com/hosted-payments/transaction_token',
    jsurl:'https://api.demo.convergepay.com/hosted-payments/Checkout.js',
    ssl_merchant_id: '0022765',
    ssl_user_id: 'apiuser',
    ssl_pin: 'WHZOY81PEWGZDA9GTDKWPBFC2VJ9VDY9JF0FKE29DHD9EM76BIPO1PJYCIYUMZZX',
    ssl_transaction_type: 'ccgettoken',
  },

  clover: {
    sdkUrl: 'https://checkout.sandbox.dev.clover.com/sdk.js',
    merchantId: '8baf4e5272eb8deaf4dfbac0503c28c9'
  },

  // Promotion    
  promotion: {
    url: 'https://promotions.beta.api.unoapp.io',
    api_token: 'Rks9wYfzmRsdJ23Jfs8Dhe&Djk9dsfk1Gdiwe7H',
  }, 

  vbout:{
    url: 'https://forwarder.beta.api.unoapp.io',
    api_key: '5238320008277607645120542',
    domain: 'VBT-68145-5700',
    domain_url: 'https://unohop.beta.unoapp.io',
  },
  
  loyality: {
    api_token: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
  },

  businessLoyality: {
    url: 'https://loyalty-service.beta.api.unoapp.io'
  },


  /**
  *  ======================================== NOT NEEDED / COMING SOON BELOW THIS =============================
  */


  /**
   * FAQ
   */
  faqUrl: 'https://faq.beta.api.unoapp.io',

  

  // Review
  reviewUrl: 'https://product-reviews.dev.api.unoapp.io',
  reviewAppId: 'a507afee6cdd53b69e5b4f0b761631aa7a3d3ddd',
  reviewAppSecret: 'bb1fa5d68702c0aefd0339c65ebc99a6be20162b',

  // Notifications
  notificationUrl: 'https://notifications.dev.api.unoapp.io',
  notificationToken: 'cbfe048b4cdcf06e8e86962e35fca040',

  // Support
  supportEmail: 'info@budler.ca',


}
export default devEnv;